/* Per-product native option picker. No framework, external assets or catalogue copy. */
(function (factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (typeof window !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { api.mount(window); });
    else api.mount(window);
  }
})(function () {
  'use strict';
  function kind(name) {
    var key = String(name).trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return /^(talla|tamano|medida|size)$/.test(key) ? 'size' : /^(color|colour)$/.test(key) ? 'color' : 'other';
  }
  function model(data) {
    if (!data || !Array.isArray(data.options) || !Array.isArray(data.variants) || !data.variants.length) throw new Error('options');
    var seen = new Set(), tuples = new Set();
    data.variants.forEach(function (row) {
      if (!/^\d+$/.test(row.id) || seen.has(row.id) || !Array.isArray(row.options) || row.options.length !== data.options.length) throw new Error('variant');
      var tuple = JSON.stringify(row.options); if (tuples.has(tuple)) throw new Error('ambiguous');
      seen.add(row.id); tuples.add(tuple);
    });
    var options = data.options.map(function (option, i) {
      if (option.position !== i) throw new Error('position');
      var values = Array.from(new Set(data.variants.map(function (row) { return row.options[i]; })));
      var type = kind(option.name);
      if (type === 'size') values.sort(new Intl.Collator('es', { numeric:true, sensitivity:'base' }).compare);
      return {name:option.name.trim(), position:i, kind:type, values:values};
    });
    return {productId:data.productId, options:options, variants:data.variants};
  }
  function matching(m, selection, except) {
    return m.variants.filter(function (row) { return row.options.every(function (value, i) { return i === except || value === selection[i]; }); });
  }
  function resolve(m, selection) { var rows = matching(m, selection, -1); return rows.length === 1 ? rows[0] : null; }
  // Display label only. Native option values, SKU and the resolver stay unchanged.
  function displayOption(m, selection, option, value) {
    if (option.kind !== 'size') return value;
    var trial = selection.slice(); trial[option.position] = value;
    var row = resolve(m, trial);
    return row && row.id === '51373531726119' ? 'L' : value;
  }
  function mount(win) {
    var doc = win.document, root = doc.querySelector('[data-variant-picker]');
    if (!root || root.dataset.mounted) return;
    var m, rendered, selected;
    try {
      m = model(JSON.parse(root.querySelector('[data-picker-data]').textContent));
      rendered = m.variants.find(function (r) { return r.id === root.dataset.renderedVariant; });
      if (!rendered) return;
      selected = rendered.options.slice();
    } catch (_) { return; }
    var form = doc.querySelector('[data-native-add]'), buybox = root.closest('.buybox'), controls = root.querySelector('[data-picker-controls]');
    var status = root.querySelector('[data-picker-status]'), fallback = root.querySelector('[data-picker-fallback]');
    if (!form || !buybox || !win.RevalBCommerce || !win.RevalBCommerce.variantURL) return;
    root.dataset.mounted = 'true';
    var expanded = false, showOtherColors=false, generation = 0, flight = null, busy = false;
    var submit = form.querySelector('button[type="submit"]');
    var initialId=rendered.id, committedDisabled=submit.disabled, committedText=submit.textContent;
    function el(tag, cls, text) { var e = doc.createElement(tag); if (cls) e.className = cls; if (text !== undefined) e.textContent = text; return e; }
    function setPending(value, message) {
      busy = value; form.dataset.variantPending = String(value); buybox.dataset.selectionPending = String(value);
      if (value) submit.disabled = true;
      if (value) submit.textContent=flight?'Actualizando…':'Completa tu selección';
      var prompt=buybox.querySelector('[data-selection-prompt]');
      if(prompt){prompt.hidden=!value;prompt.textContent=flight?'Actualizando precio y entrega…':'Elige una combinación para consultar precio y entrega.';}
      status.textContent = message || ''; root.setAttribute('aria-busy', String(value && !!flight));
    }
    function focusChoice(position, value) {
      var node = Array.from(controls.querySelectorAll('[data-option-position]')).find(function (n) { return Number(n.dataset.optionPosition) === position && (n.tagName === 'SELECT' || n.dataset.optionValue === value); });
      if (node) node.focus({preventScroll:true});
    }
    function draw(focus) {
      controls.replaceChildren();
      var sorted = m.options.slice().sort(function (a,b) { var order={size:0,other:1,color:2}; return order[a.kind]-order[b.kind] || a.position-b.position; });
      sorted.forEach(function (option) {
        if (m.variants.length === 1 && option.name === 'Title' && option.values[0] === 'Default Title') return;
        var selectedRow = resolve(m, selected);
        var sizeLabel = selectedRow && selectedRow.id === '51373531726119' ? 'Talla' : 'Medida';
        var field = el('fieldset','option-field'), label = el('legend','option-label',option.kind === 'size' ? sizeLabel : option.name);
        field.appendChild(label); controls.appendChild(field);
        if (option.kind !== 'color') {
          if (option.values.length === 1) { field.appendChild(el('span','option-fixed',displayOption(m,selected,option,option.values[0]))); return; }
          var select = el('select','option-select'); select.setAttribute('aria-label',label.textContent); select.dataset.optionPosition = option.position;
          option.values.forEach(function (value) {
            var trial=selected.slice(); trial[option.position]=value;
            var o = el('option','',displayOption(m,selected,option,value)+(resolve(m,trial)||value===selected[option.position]?'':' — otro color'));
            o.value=value; o.selected=value===selected[option.position]; select.appendChild(o);
          });
          select.addEventListener('change',function () { choose(option.position,select.value); }); field.appendChild(select); return;
        }
        var rows = matching(m, selected, option.position);
        var compatible = option.values.filter(function (value) { return rows.some(function (r) { return r.options[option.position] === value; }); });
        var choices=compatible, incompatible=option.values.filter(function(value){return !compatible.includes(value);});
        var chosen = compatible.includes(selected[option.position]) ? selected[option.position] : '';
        field.appendChild(el('span','option-color-name',chosen || 'Elige un color'));
        var list = el('div','option-swatches'); list.setAttribute('role','radiogroup'); list.setAttribute('aria-label','Color'); field.appendChild(list);
        function sample(value) { return rows.find(function(r){return r.options[option.position]===value;}) || m.variants.find(function(r){return r.options[option.position]===value;}); }
        var slots=0, visible=choices.filter(function(value) { var cost=sample(value).swatch?1:2; if(expanded)return true; if(slots+cost>12)return false; slots+=cost;return true; });
        var anchor=chosen || compatible[0];
        if (!expanded && anchor && !visible.includes(anchor)) { visible.pop(); if(!sample(anchor).swatch && slots===12)visible.pop(); visible.push(anchor); }
        var enabledVisible=visible.filter(function(value){return compatible.includes(value);});
        visible.forEach(function (value) {
          var exists=compatible.includes(value), row=sample(value);
          var button = el('button','option-swatch'); button.type='button'; button.dataset.optionPosition=option.position; button.dataset.optionValue=value;
          var availability=exists?(row.available===false?' · Agotado':''):' · No existe en esta medida o selección';
          button.setAttribute('role','radio'); button.setAttribute('aria-label',value+availability); button.title=value+availability;
          button.setAttribute('aria-checked',String(value===chosen)); button.disabled=!exists;
          button.tabIndex = value===chosen || (!chosen && value===enabledVisible[0]) ? 0 : -1;
          if (row.swatch) { var tone=el('span','option-tone'); tone.style.cssText=row.swatch; tone.setAttribute('aria-hidden','true'); button.appendChild(tone); }
          else { button.classList.add('option-swatch-text'); button.textContent=value; }
          if (exists && row.available===false) button.classList.add('option-unavailable');
          button.addEventListener('click',function () { choose(option.position,value); });
          button.addEventListener('keydown',function (event) {
            var delta=/^(ArrowRight|ArrowDown)$/.test(event.key)?1:/^(ArrowLeft|ArrowUp)$/.test(event.key)?-1:0;
            if (!delta && event.key!=='Home' && event.key!=='End') return;
            event.preventDefault(); var index=enabledVisible.indexOf(value); index=event.key==='Home'?0:event.key==='End'?enabledVisible.length-1:(index+delta+enabledVisible.length)%enabledVisible.length;
            choose(option.position,enabledVisible[index]);
          }); list.appendChild(button);
        });
        if (expanded || visible.length < choices.length) {
          var more=el('button','option-more',expanded?'Ver menos colores':'Ver los '+choices.length+' colores'); more.type='button'; more.setAttribute('aria-expanded',String(expanded));
          more.addEventListener('click',function () { expanded=!expanded; draw(); controls.querySelector('.option-more').focus({preventScroll:true}); }); field.appendChild(more);
        }
        field.appendChild(el('p','option-note',choices.some(function(value){return !!sample(value).swatch;})?'Borde: armazón · centro: mica. Muestras orientativas.':'Elige el acabado por su nombre y consulta las fotografías.'));
        if(incompatible.length){
          var details=el('details','option-other-colors'); details.open=showOtherColors;
          details.appendChild(el('summary','', 'Colores en otras medidas'+(m.options.length>2?' o estilos':'')+' ('+incompatible.length+')'));
          details.appendChild(el('p','option-note','No existen en la combinación actual. Cambia la medida'+(m.options.length>2?' o el estilo':'')+' para explorarlos.'));
          var otherList=el('div','option-swatches');details.appendChild(otherList);
          incompatible.forEach(function(value){
            var row=sample(value), button=el('button','option-swatch');button.type='button';button.disabled=true;
            button.setAttribute('aria-label',value+' · No existe en esta medida o selección');button.title=value;
            if(row.swatch){var tone=el('span','option-tone');tone.style.cssText=row.swatch;tone.setAttribute('aria-hidden','true');button.appendChild(tone);}
            else{button.classList.add('option-swatch-text');button.textContent=value;}
            otherList.appendChild(button);
          });
          details.addEventListener('toggle',function(){showOtherColors=details.open;});field.appendChild(details);
        }
      });
      if (focus) focusChoice(focus.position, focus.value);
    }
    function choose(position,value) {
      if (selected[position] === value && !busy) return;
      selected[position]=value; if (m.options[position].kind!=='color') {expanded=false;showOtherColors=false;}
      draw({position:position,value:value});
      var row=resolve(m,selected);
      if (!row) {
        generation++; if (flight) { flight.abort(); flight=null; }
        var colorAxis=m.options.find(function(o){return o.kind==='color';});
        setPending(true,colorAxis && matching(m,selected,colorAxis.position).length ? 'Elige un color disponible para esta medida.' : 'Ajusta la medida o el estilo para encontrar una combinación disponible.'); return;
      }
      navigate(row,false);
    }
    async function navigate(row,fromHistory) {
      var token=++generation; if (flight) flight.abort();
      flight=new win.AbortController(); setPending(true,'Actualizando tu selección…');
      var url=win.RevalBCommerce.variantURL(root.dataset.productUrl,row.id,win.location.href);
      var requestURL=new win.URL(url); requestURL.searchParams.set('view','reval-selection');
      var timer=win.setTimeout(function () { if (token===generation && flight) flight.abort(); },12000);
      try {
        var response=await win.fetch(requestURL.href,{credentials:'same-origin',signal:flight.signal,headers:{Accept:'text/html'}});
        if (!response.ok) throw new Error('response');
        var inert=doc.createElement('template'); inert.innerHTML=await response.text(); var next=inert.content; if (token!==generation) return;
        var nextRoot=next.querySelector('[data-variant-picker]'), nextForm=next.querySelector('[data-native-add]');
        if (!nextRoot || nextRoot.dataset.productId!==m.productId || nextRoot.dataset.renderedVariant!==row.id || !nextForm || nextForm.querySelector('[name="id"]').value!==row.id) throw new Error('identity');
        var replacements=['[data-selection-price]','.buybox>.exact','.buybox>[data-native-route]','.facts tbody','[data-selection-shipping]'];
        if (doc.querySelector('[data-selection-description]') || next.querySelector('[data-selection-description]')) replacements.push('[data-selection-description]');
        var pairs=replacements.map(function (selector) { var old=doc.querySelector(selector), fresh=next.querySelector(selector); if (!old || !fresh) throw new Error('fragment'); return [old,fresh]; });
        var nextButton=nextForm.querySelector('button[type="submit"]'), nextDelivery=nextForm.querySelector('[name="properties[Entrega]"]');
        if (!nextButton || !nextDelivery) throw new Error('delivery');
        // Commit the complete server-rendered selection together; the original
        // native form remains mounted so its delivery/cart safeguards stay active.
        pairs.forEach(function (pair) { pair[0].replaceWith(doc.importNode(pair[1],true)); });
        form.querySelector('[name="id"]').value=row.id;
        form.querySelector('[name="properties[Entrega]"]').value=nextDelivery.value;
        form.dataset.deliveryUrl=nextForm.dataset.deliveryUrl;
        doc.getElementById('variant-select').value=row.id;
        rendered=row; selected=row.options.slice(); root.dataset.renderedVariant=row.id;
        committedDisabled=nextButton.disabled; committedText=nextButton.textContent;
        row.available=!nextButton.disabled;
        doc.dispatchEvent(new win.CustomEvent('reval:variant:commit',{detail:{variantId:row.id}}));
        doc.dispatchEvent(new win.CustomEvent('reval:variant:changed',{detail:{variantId:row.id}}));
        if (!fromHistory && win.location.href!==url) win.history.pushState({revalVariant:row.id},'',url);
        flight=null; setPending(false,nextButton.disabled?'Esta combinación está agotada. Puedes consultar sus fotografías.':'');
        submit.disabled=committedDisabled; submit.textContent=committedText;
      } catch (error) {
        if (token!==generation) return;
        flight=null; setPending(true,'No pudimos actualizar esta selección. Vuelve a elegirla o recarga la ficha.');
      } finally { win.clearTimeout(timer); }
    }
    win.addEventListener('popstate',function () {
      var id=new win.URL(win.location.href).searchParams.get('variant') || initialId;
      var row=m.variants.find(function (r) { return r.id===id; });
      if (row) { selected=row.options.slice(); draw(); navigate(row,true); }
    });
    win.addEventListener('pageshow',function (event) {
      if (event.persisted) {
        generation++; if (flight) flight.abort(); flight=null;
        var urlId=new win.URL(win.location.href).searchParams.get('variant') || initialId;
        var historyRow=m.variants.find(function(r){return r.id===urlId;});
        if(historyRow && historyRow.id!==rendered.id){selected=historyRow.options.slice();draw();navigate(historyRow,true);return;}
        selected=rendered.options.slice(); draw(); setPending(false,''); submit.disabled=committedDisabled; submit.textContent=committedText;
      }
    });
    win.addEventListener('pagehide',function () { generation++; if (flight) flight.abort(); flight=null; });
    draw(); controls.hidden=false; fallback.hidden=true;
    if(m.variants.length===1 && m.options.every(function(o){return o.name==='Title' && o.values[0]==='Default Title';}))root.hidden=true;
  }
  return {kind:kind, model:model, matching:matching, resolve:resolve, displayOption:displayOption, mount:mount};
});
